<template>
    <article class="module type-module status-publish">
        <div class="module-wrap">
            <template v-if="options.closeButton">
                <a href="" class="close-button js-go-back-history" @click="window.history.back()">
                    <span class="icon-Close-Clean"></span>
                </a>
            </template>
            <template v-if="moduleUrl">
                <iframe 
                    :src="moduleUrl" 
                    class="iframe-on-page close-iframe-on-end" 
                    :data-session-finished="sessionFinishedUrl" 
                    frameborder="0"
                    ></iframe>
            </template>
        </div>
    </article>
</template>

<script>

//continue https://local.boxed.bryter-custom.io/vendor-onboarding-hub/module/1-intake-module/?env=4NkpRB7lT4mdt_TsSRogQg&a=2
export default {
    name: 'ModuleComponent',
    props: {
        templateData: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data() {
        return {
            options: {
                closeButton: false
            }
        }
    },

    computed: {
        sessionFinishedUrl() {
            let queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);

            if(urlParams.get('redirect_uri')) {
                return urlParams.get('redirect_uri');
            }

            if ( this.templateData.result_event == 'close-module' ) {
                return 'close'
            }
            return null
        },
        moduleUrl() {
            return this.templateData.module_url
        }
    }
}
</script>